import { Cache } from "aws-amplify";
export const fetchWrapper = {
  get,
  post,
  put,
  delete: _delete,
};

function get(url, params) {
  let requestOptions = {};
  if (params !== undefined && params !== null) {
    requestOptions = {
      method: "GET",
      headers: { Authorization: params },
    };
  } else if (
    Cache.getItem("ginsure_token") !== null &&
    Cache.getItem("ginsure_token") !== undefined
  ) {
    requestOptions = {
      method: "GET",
      headers: { Authorization: Cache.getItem("ginsure_token") },
    };
  } else {
    requestOptions = {
      method: "GET",
    };
  }

  return fetch(url, requestOptions).then(handleResponse);
}

function post(url, body, key) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  };

  if (
    Cache.getItem("ginsure_token") !== null &&
    Cache.getItem("ginsure_token") !== undefined
  ) {
    requestOptions.headers = {
      "Content-Type": "application/json",
      Authorization: Cache.getItem("ginsure_token"),
    };
  }

  return fetch(url, requestOptions).then(handleResponse);
}

function put(url, body, key) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };
  if (
    Cache.getItem("ginsure_token") !== null &&
    Cache.getItem("ginsure_token") !== undefined
  ) {
    requestOptions.headers = {
      "Content-Type": "application/json",
      Authorization: Cache.getItem("ginsure_token"),
    };
  }
  return fetch(url, requestOptions).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url) {
  const requestOptions = {
    method: "DELETE",
  };
  return fetch(url, requestOptions).then(handleResponse);
}

// function handleResponse(response) {
//   if (response.ok) {
//     return response.json();
//   }
//   throw response.json();
// }

// async function handleResponse(response) {
//   const contentType = response.headers.get("content-type");
//   let data = null;

//   // Try to parse JSON if content type is application/json
//   if (contentType && contentType.includes("application/json")) {
//     try {
//       data = await response.json();
//     } catch (e) {
//       // Failed to parse JSON
//       data = null;
//     }
//   }

//   if (response.ok) {
//     return data;
//   }

//   const error = new Error(data?.message || "Request failed");
//   error.status = response.status;
//   error.data = data;
//   throw error;
// }
async function handleResponse(response) {
  let data;

  try {
    data = await response.json(); // try JSON first
  } catch (e) {
    data = await response.text(); // fallback to text (HTML, etc.)
  }

  if (response.ok) {
    return data;
  }

  const error = new Error(
    (data && data.message) || data || "Request failed"
  );

  error.status = response.status;
  error.data = data;

  throw error;
}